import TaxRate from 'domains/models/tax_rate';
import { z } from 'zod';
import { TaxInclusiveEnum, TaxTypeEnum } from './enum';

export type TaxRateCreateBody = z.infer<typeof schemaTaxRateCreateBody>;
export const schemaTaxRateCreateBody = z.object({
  uid: z.string(),
  taxType: TaxTypeEnum,
  taxInclusive: TaxInclusiveEnum,
  percentage: z.number(),
});

export type TaxRateUpdateBody = z.infer<typeof schemaTaxRateUpdateBody>;
export const schemaTaxRateUpdateBody = z.object({
  taxType: TaxTypeEnum,
  taxInclusive: TaxInclusiveEnum,
  percentage: z.number(),
});

export type TaxRateCreateResult = z.infer<typeof schemaTaxRateCreateResult>;
export const schemaTaxRateCreateResult = z.object({
  id: z.number(),
});

export type TaxRateItem = z.infer<typeof schemaTaxRateItem>;
export const schemaTaxRateItem = z.object({
  id: z.number().nullable(),
  uid: z.string(),
  teamId: z.number(),
  taxType: TaxTypeEnum,
  taxInclusive: TaxInclusiveEnum,
  percentage: z.number(),
});

export type TaxRateListItem = z.infer<typeof schemaTaxRateListItem>;
export const schemaTaxRateListItem = z.object({
  id: z.number(),
  uid: z.string(),
  teamId: z.number(),
  taxType: TaxTypeEnum,
  taxInclusive: TaxInclusiveEnum,
  percentage: z.number(),
});

export const toItem = (taxRate: TaxRate): TaxRateItem => {
  return {
    id: taxRate.id!,
    uid: taxRate.uid,
    teamId: taxRate.teamId,
    taxType: taxRate.taxType,
    taxInclusive: taxRate.taxInclusive,
    percentage: taxRate.percentage,
  };
};

export const toListItem = (taxRate: TaxRate): TaxRateListItem => {
  return {
    id: taxRate.id!,
    uid: taxRate.uid,
    teamId: taxRate.teamId,
    taxType: taxRate.taxType,
    taxInclusive: taxRate.taxInclusive,
    percentage: taxRate.percentage,
  };
};
